import { toast } from "@assetwatch/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  type MotionAmplificationJobId,
  startMotionAmplificationJob,
} from "../clients/motion-amplification";
import i18n from "../i18n/config";
import { motionAmplificationJobsListKey } from "../queries/useMotionAmplificationJobsQuery";
import { removeMultipartFileHandle } from "./multipartUploadFileHandleStore";

export function useStartMotionAmplificationJobMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ["motion-amplification", "start"],
    mutationFn: (jobId: MotionAmplificationJobId) =>
      startMotionAmplificationJob(jobId),
    retry: 2,
    retryDelay: (attempt) => 1000 * 2 ** attempt,
    onSuccess: async (_result, jobId) => {
      await removeMultipartFileHandle(jobId).catch(() => undefined);
    },
    onError: (error, jobId) => {
      toast.error(error.message || i18n.t("motionAmplification.uploadError"), {
        timeout: 0,
        action: {
          label: i18n.t("motionAmplification.retryUpload"),
          onClick: () => mutation.mutate(jobId),
        },
      });
    },
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: motionAmplificationJobsListKey,
      }),
  });
  return mutation;
}
